<template>
    <v-container
      fluid
      class="full-height-with-navbar"
    >
      <div class="tabs-bar">
        <v-layout
          align-center
          v-if="!summary"
        >
          <!-- <v-icon
            class="icon--link"
            @click="translatePrev"
          >
            chevron_left
          </v-icon> -->
          <v-flex
            d-flex
            class="tabs__wrapper"
          >
            <div
              class="tabs__container tabs__container--overflow"
              :style="`transform: translateX(${translateWidth}px)`"
            >
              <div
                class="tabs__div "
                v-ripple
                v-for="(tab, i) in tabs"
                :key="i"
                @click="model = `tab-${i}`"
                :ref="`tab-${i}`"
              >
              <span
                class="tabs__item"
                :class="{'tabs__item--active': model === `tab-${i}`}"
              >{{ tab.title }}</span>
              </div>
            </div>

          </v-flex>
        </v-layout>
      </div>

      <div
        v-if="!summary"
        class="tabs-content"
      >
        <transition name="component-fade" mode="out-in">
          <component
            :is="tabComponent"
            :issues="campaign.issues"
            :messages="campaign.messages"
            :campaign="campaign"
            @setCampaignProperty="setCampaignProperty"
            @setGeoLocations="setGeoLocations"
            @setAdsetProperty="setAdsetProperty"
            @setTargeting="setTargeting"
            @addIssue="addIssue"
            @removeIssue="removeIssue"
            @createMessage="createMessage"
            @updateMessage="updateMessage"
            @next="next"
            @previous="previous"
            @confirm="confirm"
          />
        </transition>
      </div>

      <transition name="component-fade" mode="out-in">
        <summary-component
          v-if="summary"
          :campaign="campaign"
          :editCampaign="editCampaign"
          @previous="previous"
        />
      </transition>
    </v-container>
</template>
<script>
import CampaignType from './campaign-type/Index.vue'
import Audiences from './audiences/Index.vue'
import Geo from './geo/Index.vue'
import Splits from './splits/Index.vue'
import Issues from './issues/Index'
import Messages from './messages/Index'
import SuccessMetrics from './success-metrics/Index'
import FlightDetails from './flight-details/Index'
import SummaryComponent from './summary/Index'
export default {
  name: 'campaign-index',
  components: {
    CampaignType,
    Audiences,
    Splits,
    Geo,
    Issues,
    Messages,
    SuccessMetrics,
    FlightDetails,
    SummaryComponent
  },
  data () {
    return {
      model: 'tab-0',
      summary: false,
      tabs: [
        {
          title: 'Campaign Goal'
        },
        {
          title: 'Schedule & Budget'
        },
        {
          title: 'Audiences'
        },
        {
          title: 'Geo'
        },
        {
          title: 'Splits'
        },
        {
          title: 'Issues'
        },
        {
          title: 'Messages'
        },
        {
          title: 'Success Metrics'
        }
      ],
      campaign: {},
      editCampaign: false,
      translateWidth: 0,
      counter: 0
    }
  },
  created () {
    if (this.$route.params.id) {
      const campaign = this.campaigns.find(c => c.id === this.$route.params.id)
      // Note: inject exist campaign into component
      if (campaign) {
        this.initNewCampaign()
        this.campaign.name = campaign.name
        this.campaign.lifetime_budget = campaign.lifetime_budget || 0
        this.campaign.selectedBudget = 'lifetime_budget'
        if (campaign.daily_budget) {
          this.campaign.daily_budget = campaign.daily_budget
          this.campaign.selectedBudget = 'daily_budget'
        }
        this.campaign.issues = campaign.issues
        this.addMissingCampaignFields(campaign)
        if (campaign.adlabels) this.campaign.type = campaign.adlabels.map(a => a.name).join('')
        this.editCampaign = true
        // Note: update messages with issue name by issue id
        if (campaign.messages) {
          this.campaign.messages = campaign.messages.map(m => {
            const issue = campaign.issues.find(i => i.id === m.adset_id).name
            return Object.assign(m, {issue})
          })
        }
        this.campaign.targeting = campaign.targeting
      } else {
        this.initNewCampaign()
        this.$router.push({name: 'NewCampaign'})
      }
    } else {
      this.initNewCampaign()
      this.$router.push({name: 'NewCampaign'})
    }
  },
  computed: {
    tabComponent () {
      switch (this.model) {
        case 'tab-0':
          return 'campaign-type'
        case 'tab-1':
            return 'flight-details'
        case 'tab-2':
          return 'audiences'
        case 'tab-3':
          return 'geo'
        case 'tab-4':
            return 'splits'
        case 'tab-5':
          return 'issues'
        case 'tab-6':
          return 'messages'
        case 'tab-7':
          return 'success-metrics'
        default:
          return 'campaign-type'
      }
    },
    campaigns () {
      return this.$store.getters.getCampaigns
    }
  },
  methods: {
    initNewCampaign () {
      const campaign = Object.create(null)
      campaign.type = 'OF-Fundraising'
      campaign.name = this.$moment().format('MMM DD')
      campaign.lifetime_budget = 1000
      campaign.selectedBudget = 'lifetime_budget'
      campaign.start_time = this.$moment().format('YYYY-MM-DD HH:mm:ss')
      campaign.end_time = this.$moment().add('14', 'days').format('YYYY-MM-DD HH:mm:ss')
      campaign.selectedGeo = 'Nothing selected'
      campaign.daily_budget = null
      campaign.targeting = null
      campaign.adsets = []
      campaign.issues = []
      campaign.messages = []
      this.campaign = Object.assign({}, campaign)
    },
    addMissingCampaignFields (campaign) {
      // Note: some campaigns missing required fields (created in facebook console)
      if (campaign.lifetime_budget !== campaign.lifetime_budget) this.campaign.lifetime_budget = 1000
    },
    next (property, campaignProperty) {
      let currentTab = this.model.split('-')[1]
      if (currentTab >= 6) return false
      if (property) Object.assign(this.campaign[property], campaignProperty)
      currentTab++
      this.model = `tab-${currentTab}`
    },
    previous (summary) {
      if (summary) {
        this.model = `tab-6`
        this.summary = false
        return true
      }
      let currentTab = this.model.split('-')[1]
      if (currentTab <= 0) return false
      currentTab--
      this.model = `tab-${currentTab}`
    },
    confirm (campaignProperties) {
      Object.assign(this.campaign, campaignProperties)
      this.summary = true
    },
    translatePrev () {
      if (this.counter > 0) {
        this.translateWidth = 0
        this.counter = 0
      }
    },
    translateNext () {
      const element = this.$refs[`tab-${this.counter}`]
      const elWidth = element[0].getBoundingClientRect().width
      if (this.counter < 5) {
        this.translateWidth -= elWidth
        this.counter++
      }
    },
    setCampaignProperty (property, value) {
      this.campaign[property] = value
    },
    setGeoLocations (value) {
      if (!this.campaign.targeting) this.campaign.targeting = {}
      this.campaign.targeting.geo_locations = value
    },
    setAdsetProperty (property, value) {
      this.campaign.adset[property] = value
    },
    setTargeting (targeting) {
      this.campaign.targeting = targeting
    },
    addIssue (issue) {
      this.campaign.issues.push(issue)
    },
    removeIssue (issue) {
      this.campaign.issues = this.campaign.issues.filter(i => i.id !== issue.id)
    },
    createMessage (message) {
      this.campaign.messages.push(message)
    },
    updateMessage (message) {
      const index = this.campaign.messages.find(m => m.id === message.id)
      if (index) this.campaign.messages.splice(index, 1, message)
    }
  },
  watch: {
    '$route' (newPath, oldPath) {
      if (oldPath.name === 'EditCampaign') {
        this.initNewCampaign()
        this.model = 'tab-0'
      }
    }
  }
}
</script>
<style lang="scss">
  $border-color: rgb(236, 243, 247);
  .tabs-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex: 1 1 auto;

    &__container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &-action {
        width: 100%;
        border-top: 1px solid $border-color;
        align-items: end;
        padding: .5rem;
        flex: none;
      }
    }
  }
  .component-fade-enter-active {
    transition: transform .3s ease;
  }
  .component-fade-enter {
    transform: translateX(500px);
  }
</style>
